import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import MealNavbar from "./MealNavbar";
import MealBreadCrumbs from "./MealBreadCrumbs";
import { MealHeader } from "./MealHeader";
import AboutMeal from "./AboutMeal";
import MealPlaneCard from "./MealPlaneCard";
import AddOne from "./AddOne";
import Subscription from "./Subscription";
import DiscountFooterSection from "../DiscountFooterSection/DiscountFooterSection";
import Footer from "../Footer/Footer";
import { useParams } from "react-router";
import { useGetSingleMenuQuery } from "api/menu";
import { useGetAllMealPlanQuery, useGetDishesByMealplanQuery, useGetMealPlanByIdQuery } from "api/Mealplans";
import { useGetSingleCatererQuery } from "api/caterer";

const MealPlan = () => {
  const id = useParams();
  // const { MealData: getAllMealPlan } = useGetAllMealPlanQuery();
  const { data: getAllMealPlan } = useGetMealPlanByIdQuery(id.id);

  const { data: getDishes } = useGetDishesByMealplanQuery(getAllMealPlan?.data?._id);

  console.log("mealcourse price", getAllMealPlan?.data?.mealCourse[0].price);
  console.log("getemalpan", getDishes?.data);
  console.log("getemalpan onwer ID", getDishes?.data[0]?.owner);
  localStorage.setItem("catererId", getDishes?.data[0]?.owner)
  const { data: menuData } = useGetSingleMenuQuery(id.id);
  const menu = menuData?.data;

  const { data: catererData } = useGetSingleCatererQuery(getAllMealPlan?.data?.owner);
  const caterer = catererData?.caterer;

  const [dishes, setDishes] = useState([])
  useEffect(() => {
    const addPriceDish = getDishes?.data?.map((dish) =>
      ({ ...dish, price: getAllMealPlan?.data?.mealCourse[0].price })
    )
    setDishes(addPriceDish)
    console.log("addPriceDish", addPriceDish)
  }, [getDishes])



  return (
    <Box>
      <Box>
        <Box>
          <MealNavbar />
        </Box>
        <Box sx={{ mt: "70px" }}>
          <Box sx={{ margin: "20px" }}>
            <Box sx={{ margin: "10px" }}>
              <MealBreadCrumbs />
            </Box>
            <Box sx={{ mt: "20px" }}>
              <Box>
                <MealHeader id={id} menu={getAllMealPlan?.data} />
              </Box>
            </Box>
            <Box sx={{ mt: "50px" }}>
              <Box sx={{ margin: "30px" }}>
                <AboutMeal menu={getAllMealPlan?.data} caterer={caterer} />
              </Box>
            </Box>
            <Box>
              <MealPlaneCard dishesData={dishes}
              // price={getAllMealPlan?.data?.mealCourse[0].price}
              />
            </Box>
            <Box sx={{ mt: "60px" }}>
              <AddOne />
            </Box>
            <Box sx={{ mt: '70px' }}>
              <Box sx={{ margin: '25px' }}><Subscription /></Box>
            </Box>
            <Box sx={{ mt: "80px" }}>
              <Box sx={{ margin: "20px" }}>
                <DiscountFooterSection />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: "80px" }}>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default MealPlan;
